/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedSoldHeader_item$ref = any;
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItemsLanding_item$ref: FragmentReference;
export type PdpRespSimilarItemsLanding_item = {|
  +title: ?string,
  +isSold: ?boolean,
  +isListingNotListed: ?boolean,
  +isListingUnlisted: ?boolean,
  +seller: ?{|
    +isInternal: ?boolean
  |},
  +vertical: ?VerticalType,
  +isNewAndMadeToOrder: ?boolean,
  +$fragmentRefs: PdpSharedSoldHeader_item$ref,
  +$refType: PdpRespSimilarItemsLanding_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsLanding_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isSold",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isListingNotListed",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isListingUnlisted",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isInternal",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vertical",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isNewAndMadeToOrder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedSoldHeader_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '286f3c9de625703bf4cf7187de316564';
module.exports = node;
